module.exports = __webpack_public_path__ + "img/cyber-defence-24.1573c48b.svg";